require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-za-fx-fb.json") })
        }
      }, "path---photos-professional-za-fx-fb");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-za-fx-fb!./.cache/json/photos-professional-za-fx-fb.json
// module id = 1169
// module chunks = 231608221292675